/* eslint-disable */
export default {
  methods: {
    fmt(value, n, x, s, c) {
    /*
		* Number.prototype.format(n, x, s, c)
		*
		* @param integer n: length of decimal
		* @param integer x: length of whole part
		* @param mixed   s: sections delimiter
		* @param mixed   c: decimal delimiter
	  */
      let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')';
      let num = value.toFixed(Math.max(0, ~~n));

      return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    },
    formatBigNumber(value) {
      const num = value;
      let re = '';

      if (window.lang === 'english') {
        const om = (num) / 1000000;
        if (om > 0) { re += `${this.fmt(om, 2, 3, ',')}M`; }

        if (re === '') {
          return this.fmt(num, 0, 3, ',');
        }
      } else {
        let hm = parseInt(num / 1e8, 10);

        let tk = Math.round((num % 1e8) / 10000);

        if (tk >= 10000) {
          tk -= 10000;
          hm++;
        }

        if (hm > 0) { re += `${this.fmt(hm, 0, 3, ',')}億`; }
        if (tk > 0) { re += `${this.fmt(tk, 0, 3, ',')}萬`; }

        if (re === '') {
          return this.fmt(num, 0, 3, ',');
        }
      }
      return re;
    },
  },
};

